import GoogleAnalytics from '@redux-beacon/google-analytics';
import { createMiddleware } from 'redux-beacon';

import googleAnalyticsEventsMap from '@perpay-web/fintech/beacon/eventMaps/GoogleAnalytics';

export function getGoogleAnalyticsMiddleware() {
    const googleAnalytics = GoogleAnalytics();
    return createMiddleware(googleAnalyticsEventsMap, googleAnalytics);
}
